export default __webpack_public_path__ + "static/mini-cargadores-e28fc7de48bdcc852d034401783e9703.png";